import React from "react";

export default () => {
	return (
		<div>
			<span>Loading ...</span>
		</div>
	)
}
